/*====================================
=            ON DOM READY            =
====================================*/
$(function() {
  $('.js-toggle-nav').click(function() {
    // Calling a function in case we want to expand upon this.
    toggleNav();
    toggleDropdown();
	noScrolling();
  });

  $('.js-menu-dropdown').click(function() {
    // Calling a function in case we want to expand upon this.
    toggleDropdown();
  });
});

/*========================================
=            CUSTOM FUNCTIONS            =
========================================*/
function toggleNav() {
  var $menu =  $('.c-hamburger__icon, .site-navigation');
  $menu.toggleClass('is-open');
}

function toggleDropdown() {
  var $submenu = $('.site-navigation .dropdown-menu');
  $submenu.toggleClass('is-open');
}


function noScrolling() {
  var $body = $('body');
  $body.toggleClass('no-scrolling');
}